import BgGoo from "./api-playground/bg-goo";

export default function SignInPageGoo({
  speed = 0.2,
  resolution = 2.0,
  type = "default",
}: { speed?: number; resolution?: number; type?: "default" | "contour" }) {
  return <BgGoo speed={speed} resolution={resolution} depth={4} type={type} />;
}
